import { createApiServices, type GuardConfig } from '@template/api';
import { useUserStore } from '@/stores/useUserStore';
import { useAccountStore } from '@template/stores';
import api from '@/modules/axios';

/**
 * API 가드 처리 로직 (desktop 전용)
 *
 * 이 GuardConfig는 모든 API 호출에 공통으로 적용됩니다.
 * policies.ts에서 정의된 정책에 따라:
 * - 'account': 로그인 + 계좌 선택 필요
 * - 'login': 로그인 필요
 * - 'public': 인증 없이 접근 가능
 *
 * 차단 시 처리는 onBlocked에서 정의할 수 있습니다.
 */
const guardConfig: GuardConfig = {
  checkLogin: () => useUserStore().checkLoggedIn(),
  checkAccount: () => {
    const accountStore = useAccountStore();
    return !!accountStore.accountTokenComputed;
  },
  // onBlocked: (reason: 'LOGIN_REQUIRED' | 'ACCOUNT_REQUIRED') => {
  //   block된 요청 공통 처리
  // },
};

// API 서비스 인스턴스 생성 (팩토리 함수 사용)
export const {
  authService,
  accountService,
  memberService,
  openApiService,
  openApiKeyService,
  tradeService,
  executionService,
  stockService,
  termsService,
  watchlistService,
  paymentService,
  orderService,
  quoteService,
  assetService,
  kcbPhoneVerificationService,
  notificationService,
  communityQNAService,
  communityNoticeService,
  communityFAQService,
  communityEventService,
} = createApiServices({
  axiosInstance: api,
  guardConfig,
});
